import(/* webpackMode: "eager" */ "/home/autofrance.se/next-autofrance/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/autofrance.se/next-autofrance/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/autofrance.se/next-autofrance/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/autofrance.se/next-autofrance/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Outfit\",\"arguments\":[{\"variable\":\"--font-outfit\",\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"display\":\"swap\",\"preload\":true,\"adjustFontFallback\":true,\"fallback\":[\"system-ui\",\"-apple-system\",\"Segoe UI\",\"Roboto\",\"Arial\",\"sans-serif\"]}],\"variableName\":\"outfit\"}");
;
import(/* webpackMode: "eager" */ "/home/autofrance.se/next-autofrance/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/autofrance.se/next-autofrance/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AskErikBubble"] */ "/home/autofrance.se/next-autofrance/src/components/AskErikBubble.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AskErikLink"] */ "/home/autofrance.se/next-autofrance/src/components/AskErikLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackToTop"] */ "/home/autofrance.se/next-autofrance/src/components/BackToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CompareFloatingBar"] */ "/home/autofrance.se/next-autofrance/src/components/CompareFloatingBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsent"] */ "/home/autofrance.se/next-autofrance/src/components/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExitIntentPopup"] */ "/home/autofrance.se/next-autofrance/src/components/ExitIntentPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FloatingChat"] */ "/home/autofrance.se/next-autofrance/src/components/FloatingChatLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/autofrance.se/next-autofrance/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LazyOverlays"] */ "/home/autofrance.se/next-autofrance/src/components/LazyOverlays.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MiniCartSlideout"] */ "/home/autofrance.se/next-autofrance/src/components/MiniCartSlideout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileBottomNav"] */ "/home/autofrance.se/next-autofrance/src/components/MobileBottomNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PhoneClickTracker"] */ "/home/autofrance.se/next-autofrance/src/components/PhoneClickTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StickyVehicleBar"] */ "/home/autofrance.se/next-autofrance/src/components/StickyVehicleBar.tsx");
